import { useState } from 'react';
import styled from 'styled-components'
import axios from 'axios';
import { apiUrl } from '../utils/common';
import { Button, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import Modal from './Modal';
import Spinner from './Spinner';


const AddProfileForm = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin:20px 0;
`;

const AddRemoveCandidate = ({ candidate, getCandidates }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showModalConfirm, setShowModalConfirm] = useState(false);
    const [partisanship, setPartisanship] = useState('center');
    const [newProfile, setNewProfile] = useState('');
    const [deleteCandidate, setDeleteCandidate] = useState('');

    const handleCancel = () => {
        setShowModal(false);
        setShowModalConfirm(false);
        setPartisanship('center');
        setNewProfile('');
    };

    const handleAddAccountToWatch = () => {
        setShowModalConfirm(false);
        setShowModal(true);
        setNewProfile(candidate.username);
    };

    const handleCreateProfile = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        const newProfileObj = {
            username: newProfile,
            partisanship: partisanship,
            llmProfile: '',
            llmSummaryOfTheLikelyAudienceProfile: '',
        };

        try {
            await axios.post(`${apiUrl}/toxicUsers/addToxicUser`, newProfileObj);
            if (getCandidates) getCandidates();
            handleCancel();
        } catch (error) {
            console.error('Error al realizar la solicitud:', error);
        } finally {
            setIsLoading(false);
            setShowModal(false);
        }
    };

    const handleRemoveCandidate = () => {
        setShowModal(false);
        setShowModalConfirm(true);
        setDeleteCandidate(candidate);
    };

    const handleConfirmRemoval = async () => {
        setIsLoading(true);
        try {
            const response = await axios.delete(`${apiUrl}/Candidates/${deleteCandidate._id}`);
            if (response) {
                if (getCandidates) {
                    getCandidates();
                }
                setShowModalConfirm(false);
            } else {
                console.error('Error while removing candidate:', response.statusText);
            }
        } catch (error) {
            console.error('Error:', error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <Button
                sx={{ marginRight: '10px' }}
                variant="contained"
                color="primary"
                onClick={handleAddAccountToWatch}
            >
                Add to watch
            </Button>
            <Button
                variant="outlined"
                color="error"
                onClick={handleRemoveCandidate}
            >
                Remove
            </Button>

            {showModal &&
                <Modal openModal={showModal}
                    title={"Add as an account to watch"}
                    handleCloseModal={handleCancel}
                    handleSubmit={handleCreateProfile}
                    showActions={true}
                    isDisabled={isLoading}
                    buttonAction={'Create Profile'}
                    usePortal={true}
                >
                    {isLoading ? <Spinner /> :
                        <div style={{ maxHeight: '75vh', overflowY: 'auto', zIndex: 1000 }}>
                            <AddProfileForm style={{ marginLeft: '3px' }}>
                                <span>Twitter User: {newProfile}</span>
                                <FormControl component="fieldset" style={{ display: 'flex', flexDirection: 'row', alignItems: 'left' }}>
                                    <FormLabel component="legend" style={{ textAlign: 'left' }}>Partisanship</FormLabel>
                                    <RadioGroup
                                        name="partisanship"
                                        value={partisanship}
                                        onChange={(e) => setPartisanship(e.target.value)}
                                        row
                                        style={{ margin: "5px 0px" }}
                                    >
                                        <FormControlLabel value="center" control={<Radio />} label="Center" />
                                        <FormControlLabel value="left" control={<Radio />} label="Left" />
                                        <FormControlLabel value="right" control={<Radio />} label="Right" />
                                    </RadioGroup>
                                </FormControl>
                            </AddProfileForm>
                            <span style={{ marginBottom: '20px', display: 'block' }}>
                                Profile summaries and Audience summaries will automatically be generated for all new watchlist profiles.
                            </span>
                        </div>
                    }
                </Modal>
            }

            <Modal
                openModal={showModalConfirm}
                handleCloseModal={handleCancel}
                handleSubmit={handleConfirmRemoval}
                showActions={true}
                isDisabled={isLoading}
                buttonAction={'Remove Profile'}
                subtitle={'Are you sure to delete?'}
                usePortal={true}
            >
                <div style={{ marginBottom: '20px' }}>
                    <label>
                        <strong>{deleteCandidate?.username}</strong>
                    </label>
                </div>
            </Modal>
        </>
    );
};

export default AddRemoveCandidate;